import {
  jb_contact_teaser_legacy_css_default
} from "./chunk.UDCJB5GL.js";
import {
  Spaceable
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.6ORGI2J5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-contact-teaser-legacy/jb-contact-teaser-legacy.ts
var JbContactTeaserLegacy = class extends ChangesBackgroundColor(Spaceable(r)) {
  constructor() {
    super(...arguments);
    this.color = "blue";
  }
  _getContentSpacingProperties() {
    return { colsMdUp: 8 };
  }
  render() {
    const classes = { white_teaser: this.color === "white" };
    return ke`
      <div class="${Rt(classes)}">
        <h4>${this.headline}</h4>
        <h2>${this.subheadline}</h2>
        ${this.text ? ke`<p>${this.text}</p>` : D}
        <jb-button-panel .align=${"center"}><slot></slot></jb-button-panel>
      </div>
    `;
  }
};
JbContactTeaserLegacy.styles = jb_contact_teaser_legacy_css_default;
__decorateClass([
  n()
], JbContactTeaserLegacy.prototype, "color", 2);
__decorateClass([
  n()
], JbContactTeaserLegacy.prototype, "headline", 2);
__decorateClass([
  n()
], JbContactTeaserLegacy.prototype, "subheadline", 2);
__decorateClass([
  n()
], JbContactTeaserLegacy.prototype, "text", 2);
JbContactTeaserLegacy = __decorateClass([
  customElement("jb-contact-teaser-legacy")
], JbContactTeaserLegacy);

export {
  JbContactTeaserLegacy
};
